import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { getInputFieldHeightValue, InputFieldBaseProps } from "../../../util/inputFieldBaseProps";
import { formInputTheme } from "./formInputTheme";

export interface TextInputRootBaseProps extends InputFieldBaseProps {
    themeMode: RequiredThemeKeys;
}

export const TextInputRootBase = styled("div")<TextInputRootBaseProps>`
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: ${({ themeMode, inputFieldHeight }) =>
        `var(--sds--form--height--${inputFieldHeight === 32 ? "default" : "large"}, ${formInputTheme.height[
            getInputFieldHeightValue(themeMode, inputFieldHeight)
        ](themeMode)}px)`};
    color: var(--sds--form--color--value);
`;
